export interface SupplierQuestionnaireContactLineData {
	email: string;
	name: string;
	position: string;
	role: string;
	telephone: string;
}

export class SupplierQuestionnaireContactLineData implements SupplierQuestionnaireContactLineData {
	email = "";
	name = "";
	position = "";
	role = "";
	telephone = "";

	constructor(data?: Partial<SupplierQuestionnaireContactLineData>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
